var $7dcec6e18cbd77ea$exports = {};
$7dcec6e18cbd77ea$exports = {
    "alert": `Ostrze\u{17C}enie`,
    "dismiss": `Zignoruj`
};


export {$7dcec6e18cbd77ea$exports as default};
//# sourceMappingURL=pl-PL.mjs.map
